import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Button, Typography } from '@mui/material';
import { ShieldOff } from 'lucide-react';

import { selectIsOwner, selectUserMenu } from '../Redux/slices/authSlice';

export const isLoggedIn = () => {
  return !!localStorage.getItem('authx_access_token');
};

// pages every signed-in user may open
const ALWAYS_ALLOWED = ['/', '/dashboard', '/dashboard/default'];
// pages that ride on another module
const ALIASES = { '/export': '/qr-batch' };

const collectUrls = (items = [], out = new Set()) => {
  items.forEach((i) => {
    if (i.url) out.add(`/${String(i.url).trim().replace(/^\/+/, '').toLowerCase()}`);
    if (i.children?.length) collectUrls(i.children, out);
  });
  return out;
};

const isPathAllowed = (pathname, menu) => {
  const path = (pathname.replace(/\/+$/, '') || '/').toLowerCase();
  if (ALWAYS_ALLOWED.includes(path)) return true;
  const urls = collectUrls(menu);
  const base = ALIASES[path] || path;
  for (const u of urls) {
    if (base === u || base.startsWith(`${u}/`)) return true;
  }
  return false;
};

// The sidebar is built from the role's menu permissions; opening a page by typing its URL must obey the same rule.
export const RequireAuth = () => {
  const token = localStorage.getItem('authx_access_token');
  const isOwner = useSelector(selectIsOwner);
  const menu = useSelector(selectUserMenu);
  const { pathname } = useLocation();

  if (!token) return <Navigate to="/login" replace />;

  if (!isOwner && menu?.length && !isPathAllowed(pathname, menu)) {
    return (
      <Box sx={{ textAlign: 'center', py: 10 }}>
        <ShieldOff size={40} color="#98A2B3" />
        <Typography variant="h5" sx={{ mt: 2 }}>You do not have access to this page</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 2 }}>
          Ask your administrator to give your role the matching menu.
        </Typography>
        <Button variant="contained" href="/dashboard">Go to dashboard</Button>
      </Box>
    );
  }
  return <Outlet />;
};
